// src/components/Admin/PostManager/CreatePostPointSetting.jsx
import { useEffect, useState } from 'react';
import { Box, TextField, Button, Stack } from '@mui/material';
import api from '../../../api/axios';

export default function CreatePostPointSetting() {
    const [policy, setPolicy] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api
            .get('/api/point-policy/?action=create_post')
            .then((res) => {
                if (res.data?.length) setPolicy(res.data[0]);
            })
            .catch(() => alert('포인트 정책 불러오기 실패'))
            .finally(() => setLoading(false));
    }, []);

    const handleSave = () => {
        if (!policy) return alert('정책을 불러오지 못했습니다.');
        api
            .put(`/api/point-policy/${policy.id}/`, {
                action: policy.action,
                amount: policy.amount,
            })
            .then(() => alert('포인트 정책이 저장되었습니다.'))
            .catch(() => alert('저장 실패'));
    };

    if (loading || !policy) return null;

    return (
        <Box sx={{ p: 2, maxWidth: '100%' }}>
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                sx={{ mt: 2, alignItems: { xs: 'stretch', sm: 'center' } }}
            >
                <TextField
                    label="지급 Leaf"
                    type="number"
                    value={policy.amount}
                    onChange={(e) =>
                        setPolicy((prev) => ({ ...prev, amount: Number(e.target.value) }))
                    }
                    inputProps={{ min: 0 }}
                    sx={{ width: { xs: '100%', sm: 120 } }}
                />
                <Button
                    variant="contained"
                    onClick={handleSave}
                    fullWidth
                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                >
                    저장
                </Button>
            </Stack>
        </Box>
    );
}
